import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false
})
export class ResetPasswordComponent implements OnInit {
  
  token: string = '';
  success: boolean = false;
  form!: FormGroup;
  isLoading: boolean = false;
  isCheckingToken: boolean = true;
  isTokenValid: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: any) => {
      this.token = params.get('token') || '';
      this.checkTokenValidity();
    });
    this.form = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/[!@#$%^&*(),.?":{}|<>]/)]]
    });
  }

  checkTokenValidity() {
    this.authService.isResetPasswordTokenValid(this.token).subscribe((result) => {
      this.isCheckingToken = false;
      this.isTokenValid = true;
    }, () => {
      this.isCheckingToken = false;
      this.isTokenValid = false;
    });
  }

  changePassword() {
    this.isLoading = true;
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.authService.resetPassword(this.token, this.form.value['password']).subscribe((result) => {
      this.success = true;
      this.isLoading = false;
    });
  }

  goToLogin() {
    this.router.navigate(['login']);
  }

  requestNewLink() {
    this.router.navigate(['forgot-password']);
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}